import { Pagination } from "antd";
import styles from "./DetailListTable.module.scss";
import { useCallback, useMemo, useState } from "react";
import Button from "@src/components/button/Button";
import CloseIcon from "src/assets/icons/close.svg?react";
import ChevronLeft from '../../assets/chevron-left.svg?react'
import ChevronRight from '../../assets/chevron-right.svg?react'

import ReactDataGrid from "@inovua/reactdatagrid-community";
import OverflowTooltip from "@src/components/overflowTooltip/OverflowTooltip";
import { shortenYearFormatDate } from "@src/utils/time";

const columns = [
  {
    name: "completedAt",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 1.7,
    sortable: false,
    resizable: false,
    style: {
      paddingLeft: "20px",
    },
    render: ({ value }) => shortenYearFormatDate(value)
  },
  {
    name: "grade",
    header: null,
    defaultFlex: 1.5,
    textAlign: "start" as any,
    sortable: false,
    resizable: false,
    render: ({ value }) => {
      return (
        <OverflowTooltip
          text={(value ?? "")
            .replace(" Program", "")
            .replace(/[[\]\\"]/g, "")
            .replace(/,/g, ", ")}
          width={140}
        />
      );
    },
    style: {
      paddingLeft: "20px",
    },
  },
  {
    name: "teacherName",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 3,
    sortable: false,
    resizable: false,
    style: {
      paddingLeft: "20px",
    },
  },
  {
    name: "lessonName",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 3,
    sortable: false,
    resizable: false,
    style: {
      paddingLeft: "20px",
    },
  },
  {
    name: "lessonType",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 2.3,
    sortable: false,
    resizable: false,
    style: {
      paddingLeft: "20px",
    },
  },
];

const auColumns = [
  {
    name: "completedAt",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 1.6,
    sortable: false,
    resizable: false,
    style: {
      paddingLeft: "20px",
    },
    render: ({ value }) => shortenYearFormatDate(value)
  },
  {
    name: "grade",
    header: null,
    defaultFlex: 1.3,
    textAlign: "start" as any,
    sortable: false,
    resizable: false,
    render: ({ value }) => {
      return (
        <OverflowTooltip
          text={(value ?? "")
            .replace(" Program", "")
            .replace(/[[\]\\"]/g, "")
            .replace(/,/g, ", ")}
          width={110}
        />
      );
    },
    style: {
      paddingLeft: "20px",
    },
  },
  {
    name: "teacherName",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 2,
    sortable: false,
    resizable: false,
    style: {
      paddingLeft: "20px",
    },
  },
  {
    name: "lessonName",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 3,
    sortable: false,
    resizable: false,
    style: {
      paddingLeft: "20px",
    },
  },
  {
    name: "unitName",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 2.5,
    sortable: false,
    resizable: false,
    style: {
      paddingLeft: "20px",
    },
    render: ({ value }) => {
      return <div style={{fontSize: 15}}>{value ? value : 'Standalone Lesson'}</div>
    }
  }
];

const quizColumns = [
  {
    name: "dateCompleted",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 1.75,
    sortable: false,
    resizable: false,
    style: {
      paddingLeft: "20px",
    },
    render: ({ value }) => shortenYearFormatDate(Number(value))
  },
  {
    name: "grade",
    header: null,
    defaultFlex: 1.5,
    textAlign: "start" as any,
    sortable: false,
    resizable: false,
    render: ({ value }) => {
      return (
        <OverflowTooltip
          text={(value ?? "")
            .replace(" Program", "")
            .replace(/[[\]\\"]/g, "")
            .replace(/,/g, ", ")}
          width={150}
        />
      );
    },
    style: {
      paddingLeft: "20px",
    },
  },
  {
    name: "educator",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 2.5,
    sortable: false,
    resizable: false,
    style: {
      paddingLeft: "20px",
    },
  },
  {
    name: "responses",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 1.5,
    sortable: false,
    resizable: false,
    render: ({ value }) => {
      return (
        <div style={{display: 'flex', justifyContent: 'center'}}>{value}</div>
      )
    }
  },
  {
    name: "score",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 2,
    sortable: false,
    resizable: false,
    render: ({ value }) => {
      return (
        <div style={{display: 'flex', justifyContent: 'center'}}>{`${value}%`}</div>
      )
    }
  },
];

const exitticketColumns = [
  {
    name: "dateCompleted",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 1.5,
    sortable: false,
    resizable: false,
    style: {
      paddingLeft: "20px",
    },
    render: ({ value }) => shortenYearFormatDate(Number(value))
  },
  {
    name: "grade",
    header: null,
    defaultFlex: 1.3,
    textAlign: "start" as any,
    sortable: false,
    resizable: false,
    render: ({ value }) => {
      return (
        <OverflowTooltip
          text={(value ?? "")
            .replace(" Program", "")
            .replace(/[[\]\\"]/g, "")
            .replace(/,/g, ", ")}
          width={150}
        />
      );
    },
    style: {
      paddingLeft: "20px",
    },
  },
  {
    name: "educator",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 1.75,
    sortable: false,
    resizable: false,
    style: {
      paddingLeft: "20px",
    },
  },
  {
    name: "lessonName",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 2.5,
    sortable: false,
    resizable: false,
    render: ({ value }) => {
      return (
        <OverflowTooltip
          text={(value ?? "")
            .replace(" Program", "")
            .replace(/[[\]\\"]/g, "")
            .replace(/,/g, ", ")}
          width={275}
        />
      );
    },
    style: {
      paddingLeft: "20px",
    },
  },
  {
    name: "responses",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 1,
    sortable: false,
    resizable: false,
    render: ({ value }) => {
      return (
        <div style={{display: 'flex', justifyContent: 'center'}}>{value}</div>
      )
    }
  },
  {
    name: "score",
    header: null,
    textAlign: "start" as any,
    defaultFlex: 1.5,
    sortable: false,
    resizable: false,
    render: ({ value }) => {
      return (
        <div style={{display: 'flex', justifyContent: 'center'}}>{`${value}%`}</div>
      )
    }
  },
];

type Props = {
  handleClose: () => void;
  completedLessons: any[];
  isAussie: boolean;
  isExitTicket?: boolean;
  isPreprogramQuiz?: boolean;
};

const perPage = 10;

function DetailListTable(props: Props) {
  const { completedLessons, isAussie, isExitTicket=false, isPreprogramQuiz=false, handleClose } = props;
  const [skip, setSkip] = useState(perPage);
  const [currentPage, setCurrentPage] = useState(1);

  const handleLimitChange = () => {
    setSkip(skip)
  }

  const itemRender = useCallback((_, type, originalElement) => {
    if (type === "prev") {
      return <ChevronLeft className={styles.pagePrev} />;
    }
    if (type === "next") {
      return <ChevronRight className={styles.pageNext} />;
    }
    return originalElement;
  },[]);

 const handleChangePage = useCallback((page: number) => {
    setCurrentPage(page);
    const newSkip = page * perPage;
    setSkip(Math.max(0, newSkip));
  }, []);

  const renderPaginationToolbar = useCallback(() => {
    return <div className={styles.paginationView}>
      <Pagination current={currentPage} total={completedLessons.length} onChange={handleChangePage} className={styles.pagination} itemRender={itemRender} showSizeChanger={false} />
    </div>
  }, [currentPage, completedLessons.length, itemRender, handleChangePage])

  const headerStyles = useMemo(() => {
    if (isExitTicket) {
      return styles.exitticketHeader;
    } else if (isPreprogramQuiz) {
      return styles.quizHeader;
    } else if (isAussie) {
      return styles.auDetailHeader;
    }
    return styles.detailHeader;
  }, [isExitTicket, isPreprogramQuiz, isAussie])

  const tableColumns = useMemo(() => {
    if (isExitTicket) {
      return exitticketColumns;
    } else if (isPreprogramQuiz) {
      return quizColumns;
    } else if (isAussie) {
      return auColumns;
    } else {
      return columns;
    }
  }, [isExitTicket, isPreprogramQuiz, isAussie])

  return (
    <div className={styles.wrapper}>
      <div className={headerStyles}>
        <div className={styles.detailName}>Date Completed</div>
        <div className={styles.gradeTitle}>Grade</div>
        <div className={styles.detailName}>Educator</div>
        {((isAussie || isExitTicket) && !isPreprogramQuiz) && <div className={styles.detailTitle}>
          <span>Lesson Name</span>
        </div>}
        {(isPreprogramQuiz || isExitTicket) && <div className={styles.detailTitle}>
          <span>Responses</span>
        </div>}
        {(isPreprogramQuiz || isExitTicket) ? <div className={styles.detailTitle}>
          <span>Result</span>
          <Button
            label="Close"
            size="small"
            outline
            onClick={handleClose}
            className={styles.closeButton}
            rightIcon={<CloseIcon className={styles.closeIcon} />}
          />
        </div> : <div className={styles.detailTitle}>
          <span>{isAussie ? 'Unit Name' : 'Lesson Name'}</span>
          {isAussie && <Button
            label="Close"
            size="small"
            outline
            onClick={handleClose}
            className={styles.closeButton}
            rightIcon={<CloseIcon className={styles.closeIcon} />}
          />}
        </div>}
        {(!isPreprogramQuiz && !isExitTicket && !isAussie) && <div className={styles.detailTitle}>
          <span>Lesson Type</span>
          <Button
            label="Close"
            size="small"
            outline
            onClick={handleClose}
            className={styles.closeButton}
            rightIcon={<CloseIcon className={styles.closeIcon} />}
          />
        </div>
        }
      </div>
      {completedLessons.length && (
        <ReactDataGrid
          idProperty="id"
          columns={tableColumns}
          headerHeight={0}
          rowHeight={46}
          dataSource={completedLessons.map((elem, index) => ({
            id: `el_${index}`,
            ...elem,
          }))}
          style={{ minHeight: 540, border: 'none' }}
          pagination={true}
          limit={perPage}
          skip={skip-perPage}
          onSkipChange={setSkip}
          onLimitChange={handleLimitChange}
          showColumnMenuTool={false}
          enableSelection={false}
          checkboxColumn={false}
          defaultShowHeader={false}
          showHeader={false}
          renderPaginationToolbar={renderPaginationToolbar}
        />
      )}
    </div>
  );
}
export default DetailListTable;
